/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './cdn-upload-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-cdn-upload-list-page',
  template
})
export class CdnUploadListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.cdn-uploads.cdn-upload';

  columns: AdminListColumn[] = [
    {param: 'fileName', label: 'name', sortable: false},
    {param: 'cdnId', label: 'cdnUrl', sortable: false},
    {param: 'mimeType'},
    {param: 'fileSizeBytes'},
    {param: 'width', label: 'dimensions', numeric: true},
    {param: 'createTime'},
    {param: 'updateTime'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }

  httpsPrefix(value: string): string {
    return value && value.indexOf('//') === 0 ? 'https:' + value : value;
  }
}
